import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Common from "./../../common.json";
import TodayFaqs from "./TodayFaqs";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
});
export default function TodaysActivity() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [getRec, setgetRec] = useState(false);
  const [getAllData, setgetAllData] = useState(false);
  const [setTime, setsetTime] = useState("");

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getTodayActivityList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setgetRec(response.data.getRec);
        setgetAllData(response.data.getAllData);
        setsetTime(response.data.setTime);
      },
      mobile,
      web_token
    );
  }, [column, mobile, web_token]);

  return (
    <>
      <GlobalHelmet {...Common?.todayActivity} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <button
                  className="btn btn-success"
                  title="Reload Page"
                  onClick={refreshPage}
                >
                  <i className="fa fa-refresh"></i>
                </button>
                &nbsp;
                <Link
                  className="btn btn-success"
                  to="/stock-market-today"
                >
                  <i className="fa fa-arrow-left"></i>
                </Link>
              </div>
              <Breadcrumbs page="Today`s Activity" />
              <h1 className="highlighttext"> Today`s Activity</h1>

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <p>Get fii dii data today. Explore fii dii data nse like fii index future data, fii  index option data, fii stock future data, fii stock option data, trade stats for future index and stocks, index premiums, stock premiums, advance decline nse, no of 52 week high stocks, no of 52 week low stocks, unchanged stocks, put call ratio nse, india vix, nifty and bank nifty live share prices. Explore these below data to find nifty and bank nifty directions to trade in the Indian stock market. </p>
                      <div className="mt-2">
                        <div className="  mb-4 ">
                          <div className="row">
                            <div className="col-sm-6">
                              {getRec ? (
                                <>
                                  <p size="3" className="ltp-text font-bold ">
                                    FII/DII Stats
                                    <label className="float-r">
                                      Updated : {setTime}
                                    </label>
                                  </p>

                                  <table className="table table-bordered">
                                    <thead>
                                      <tr className="header-row changefont">
                                        <th className="indexname" size="3">
                                          Parameters
                                        </th>
                                        <th className="ltp" size="3">
                                          Pre. Value(Cr.)
                                        </th>
                                        <th className="signal" size="3">
                                          Today`s Value(Cr.)
                                        </th>
                                        <th className="change" size="3">
                                          Impact
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          FII Index Fut
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIIndexFutcolor"],
                                          }}
                                        >
                                          {getRec[1]["FIIIndexFut"]}
                                        </td>
                                        <td
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIIndexFutcolor"],
                                          }}
                                        >
                                          {getRec[0]["FIIIndexFut"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIIndexFutclr"],
                                          }}
                                        >
                                          {getRec[1]["FIIIndexFutImp"]}
                                        </td>
                                      </tr>

                                      <tr
                                        className="indexname symbol-text"
                                        size="3"
                                      >
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          FII Stock Opt
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIIndexOptcolor"],
                                          }}
                                        >
                                          {getRec[1]["FIIIndexOpt"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIIndexOptcolor"],
                                          }}
                                        >
                                          {getRec[0]["FIIIndexOpt"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIIndexOptclr"],
                                          }}
                                        >
                                          {getRec[1]["FIIIndexOptImp"]}
                                        </td>
                                      </tr>
                                      <tr
                                        className="indexname symbol-text"
                                        size="3"
                                      >
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          FII Stock Fut
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIStockFutcolor"],
                                          }}
                                        >
                                          {getRec[1]["FIIStockFut"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color:
                                              getRec[1]["FIIStockFutcolor"],
                                          }}
                                        >
                                          {getRec[0]["FIIStockFut"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIStockFutclr"],
                                          }}
                                        >
                                          {getRec[1]["FIIStockFutImp"]}
                                        </td>
                                      </tr>
                                      <tr
                                        className="indexname symbol-text"
                                        size="3"
                                      >
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          FII Stock Opt
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIItockOptcolor"],
                                          }}
                                        >
                                          {getRec[1]["FIItockOpt"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIItockOptcolor"],
                                          }}
                                        >
                                          {getRec[0]["FIItockOpt"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIItockOptclr"],
                                          }}
                                        >
                                          {getRec[1]["FIItockOptImp"]}
                                        </td>
                                      </tr>
                                      <tr
                                        className="indexname symbol-text"
                                        size="3"
                                      >
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          FII/FPI Cash
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIFPICashcolor"],
                                          }}
                                        >
                                          {getRec[1]["FIIFPICash"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIFPICashcolor"],
                                          }}
                                        >
                                          {getRec[0]["FIIFPICash"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["FIIFPICashclr"],
                                          }}
                                        >
                                          {getRec[1]["FIIFPICashImp"]}
                                        </td>
                                      </tr>
                                      <tr
                                        className="indexname symbol-text"
                                        size="3"
                                      >
                                        <th
                                          className="indexname symbol-text"
                                          size="3"
                                        >
                                          DII Cash
                                        </th>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["DIICashcolor"],
                                          }}
                                        >
                                          {getRec[1]["DIICash"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["DIICashcolor"],
                                          }}
                                        >
                                          {getRec[0]["DIICash"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[1]["DIICashclr"],
                                          }}
                                        >
                                          {getRec[1]["DIICashImp"]}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Put/Call Ratio
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          colSpan="2"
                                        >
                                          {getRec[0]["PutCallRatio"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["PutCallRatioImp"]}
                                        </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </>
                              ) : (
                                ""
                              )}

                              {getAllData ? (
                                <>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr className="header-row changefont">
                                        <th className="indexname" size="3">
                                          Index
                                        </th>
                                        <th className="ltp" size="3">
                                          LTP
                                        </th>
                                        <th className="signal" size="3">
                                          Signal
                                        </th>
                                        <th className="change" size="3">
                                          %chg
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {getAllData.map((item) => (
                                        <tr key={item.market_id}>
                                          <td size="3" className="ltp ltp-text">
                                            {item.symbol}
                                          </td>
                                          <td size="3" className="ltp ltp-text">
                                            {item.l}
                                          </td>
                                          <td size="3" className="ltp ltp-text">
                                            {item.signal}
                                          </td>
                                          <td size="3" className="ltp ltp-text">
                                            {item.cp}%
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6">
                              <p size="3" className="ltp-text font-bold">
                                Trade Stats
                              </p>

                              {getRec ? (
                                <>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr className="header-row changefont">
                                        <th className="indexname" size="3">
                                          Parameters
                                        </th>
                                        <th className="ltp" size="3">
                                          Pre. Value(Cr.)
                                        </th>
                                        <th className="signal" size="3">
                                          Today`s Value(Cr.)
                                        </th>
                                        <th className="change" size="3">
                                          Impact
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Index Fut
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["IndexFut"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["IndexFut"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[0].IndexFutimpcl,
                                          }}
                                        >
                                          {getRec[0].IndexFutimp}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Stock Fut
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["StockFut"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["StockFut"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[0].StockFutimpcl,
                                          }}
                                        >
                                          {getRec[0].StockFutimp}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Index Fut
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["IndexOpt"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["IndexOpt"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0].IndexOptimp}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Stock Opt
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["StockOpt"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["StockOpt"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[0].StockOptimpcl,
                                          }}
                                        >
                                          {getRec[0].StockOptimp}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Index Prem
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["IndexPrem"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["IndexPrem"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0].IndexPremimp}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Stock Prem
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["StockPrem"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["StockPrem"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0].StockPremimp}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <table className="table table-bordered">
                                    <thead>
                                      <tr className="header-row changefont">
                                        <th className="indexname" size="3">
                                          Parameters
                                        </th>
                                        <th className="ltp" size="3">
                                          Pre. Value
                                        </th>
                                        <th className="signal" size="3">
                                          Today`s Value
                                        </th>
                                        <th className="change" size="3">
                                          Impact
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Adv
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["Adv"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["Adv"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{ color: getRec[0]["Advsi"] }}
                                        >
                                          {getRec[0]["Advs"]}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Dec
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["Decd"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["Decd"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{ color: getRec[0]["Decdsi"] }}
                                        >
                                          {getRec[0]["Decds"]}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          Unchanged
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["Unchanged"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["Unchanged"]}
                                        </td>
                                        <td
                                          className="ltp ltp-text"
                                          style={{
                                            color: getRec[0]["Unchangedsi"],
                                          }}
                                        >
                                          {getRec[0]["Unchangeds"]}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          52WH
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["52WH"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["52WH"]}
                                        </td>
                                        <td
                                          size="3"
                                          className="ltp ltp-text"
                                          style={{ color: getRec[0]["52WHsi"] }}
                                        >
                                          {getRec[0]["52WHs"]}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td size="3" className="ltp ltp-text">
                                          52WL
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[1]["52WL"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["52WL"]}
                                        </td>
                                        <td size="3" className="ltp ltp-text">
                                          {getRec[0]["52WLs"]}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">                        
                        <TodayFaqs />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
